var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsYoutubeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.415 9.26a3.506 3.506 0 00-2.476-2.475C24.756 6.199 16 6.199 16 6.199s-8.756 0-10.94.586A3.506 3.506 0 002.586 9.26C2 11.443 2 16 2 16s0 4.557.585 6.74a3.506 3.506 0 002.476 2.475C7.244 25.8 16 25.8 16 25.8s8.756 0 10.939-.585a3.506 3.506 0 002.476-2.476C30 20.558 30 16 30 16s-.002-4.556-.585-6.739z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.197 20.2l7.275-4.2-7.275-4.2v8.4z",
    fill: "#fff"
  })));
}

export default SvgIconSnsYoutubeFilled;